import { render } from "./ActionsComponent.vue?vue&type=template&id=47f9a6dc&scoped=true"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"

import "./ActionsComponent.vue?vue&type=style&index=0&id=47f9a6dc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f9a6dc"]])

export default __exports__